// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg fill=\"%23333\" height=\"20\" viewBox=\"0 0 24 24\" width=\"20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7 10l5 5 5-5z\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ManageDownload.css - Final Revised Version */

/* ======================================================= */
/* 🔑 VARIABLES & KEYFRAMES */
/* ======================================================= */
/* Defining common colors and fonts for easier maintenance */
:root {
    --primary-blue: #3498db;
    --primary-green: #2ecc71;
    --primary-red: #e74c3c;
    --text-dark: #34495e;
    --text-light: #666;
    --bg-dark: #303030;
    --bg-light: #fff;
    --border-color: #e0e6ed;
}

@keyframes modalFadeIn {
    from {
        transform: scale(0.95);
        opacity: 0;
    }
    to {
        transform: scale(1);
        opacity: 1;
    }
}


/* ======================================================= */
/* 📱 MOBILE LAYOUT (Default styles for screens < 768px) */
/* ======================================================= */

/* --- Global & Container Styles --- */

.AddProduct {
    padding: 1px 10px;
    background-color: var(--bg-dark);
    min-height: 100vh;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.AddProduct h1 {
    color: var(--bg-light);
    font-size: 1.3rem;
    text-align: center;
    margin: 30px 10px;
    /* font-family: 'GlitchGoblin', sans-serif; // Ensure this font is imported */
    font-weight: 600;
}

.product-page-container {
    width: 100%;
    margin: 20px auto;
    background-color: var(--bg-light);
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05); 
    overflow: auto;
}

/* --- Button Group Layout (Mobile Stacking) --- */
.button-group {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-bottom: 25px;
}

/* --- Primary Add Buttons --- */
.AddProduct .add-button {
    background-color: var(--primary-blue);
    color: white;
    border: none;
    padding: 10px 20px;
    font-size: 0.95rem;
    font-weight: 600;
    cursor: pointer;
    border-radius: 6px;
    transition: background-color 0.3s ease, transform 0.2s ease;
    box-shadow: 0 3px 8px rgba(52, 152, 219, 0.2);
    width: auto;
    margin: 0;
    white-space: nowrap;
}

.AddProduct .add-button:hover {
    background-color: #2980b9; 
    transform: translateY(-1px); 
}

/* --- Table Styling --- */

.data-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    border-radius: 8px;
    overflow: hidden;
    overflow-x: auto;
    white-space: nowrap; 
}

th, td {
    padding: 10px;
    text-align: left;
    border-bottom: 1px solid #666;
    font-size: 0.9rem;
}

/* Text Truncation for Table Data on mobile to prevent overflow */
.data-table tbody td {
    max-width: 150px; 
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.data-table tbody td.actions-cell {
    max-width: none;
    overflow: visible;
    white-space: nowrap;
}


th {
    background-color: #f8f9fa;
    color: #495057;
    font-weight: 600;
    text-transform: uppercase;
}

tbody tr:nth-child(odd) { background-color: var(--bg-light); color: var(--text-light); }
tbody tr:nth-child(even) { background-color: #fcfcfc; color: var(--text-light); }

/* --- Table Action Buttons --- */
.AddProduct td button {
    /* Base style for all table buttons (Edit/Delete) */
    margin-right: 5px; 
    padding: 6px 10px; 
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 0.8rem;
    background-color: #f0f3f5;
    color: var(--text-dark);
    transition: background-color 0.3s ease;
    width: auto; 
}

.AddProduct td button:hover {
    background-color: #e2e6ea;
}

/* 🌟 REVISION: Explicit Styling for the Edit Button (First Child) 🌟 */
.AddProduct td button:first-child { 
    background-color: #3498db; /* Primary Blue from your variables */
    color: white;
    border-color: #3498db;
}

.AddProduct td button:first-child:hover {
    background-color: #2980b9;
    border-color: #2980b9;
}


/* Table Delete Button (2nd button in the cell in this case) */
.AddProduct td button:nth-child(2) {
    background-color: var(--primary-red);
    color: white;
    border-color: var(--primary-red);
}

.AddProduct td button:nth-child(2):hover {
    background-color: #c0392b;
}


/* ======================================================= */
/* 🚀 FORM & MODAL STYLING */
/* ======================================================= */

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal-content {
    background: var(--bg-light);
    padding: 20px; 
    border-radius: 8px; 
    position: relative;
    width: 80%; 
    max-width: none; 
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
    opacity: 0;
    animation: modalFadeIn 0.3s forwards;
    max-height: 90vh; 
    overflow-y: auto;
}

.close-button {
    position: absolute;
    top: 15px;
    right: 15px;
    background: transparent;
    border: none;
    font-size: 2rem; 
    cursor: pointer;
    color: #95a5a6;
    transition: color 0.2s ease;
}

.close-button:hover {
    color: var(--primary-red);
}

/* --- Form Groups & Input Styles --- */

form > div {
    /* General spacing for form fields */
    margin-bottom: 20px;
}

form label {
    display: block;
    margin-bottom: 8px;
    font-weight: 600;
    color: var(--text-dark);
    font-size: 0.95rem;
}

form input[type="text"],
form input[type="number"],
form textarea,
.selectedProduct { 
    width: 100%;
    padding: 10px;
    border: 1px solid var(--border-color);
    border-radius: 6px;
    box-sizing: border-box;
    font-size: 0.95rem;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

form input:focus,
form textarea:focus,
.selectedProduct:focus {
    outline: none;
    border-color: var(--primary-blue);
    box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.2);
}

/* 🌟 INPUT GROUP FOR INPUT + BUTTON 🌟 */
.FormInputGroup .input-with-button {
    display: flex;
    align-items: center; 
    gap: 10px; 
}

/* Ensure the input takes up all remaining space */
.FormInputGroup .input-with-button input[type="text"] {
    flex-grow: 1;
    min-width: 0; 
}

/* Style the buttons within the input group to look like the APK button */
.FormInputGroup-button {
    flex-shrink: 0; 
    width: 140px; /* Consistent width for both "Select Image" and "Select APK" */
    padding: 10px 15px;
    font-size: 0.95rem;
    margin: 0 !important; /* Override any potential external margin */
    /* Visual style is inherited from .add-button */
}


/* --- Modal Submission Button --- */
.AddProduct .modal-content form button[type="submit"] {
    width: 100%;
    padding: 12px;
    background-color: var(--primary-green);
    font-weight: 700;
    font-size: 1rem;
    border-radius: 6px;
    color: white;
    border: none;
    margin-top: 15px;
}

.AddProduct .modal-content form button[type="submit"]:hover {
    background-color: #27ae60;
}

/* --- Helper/Note Styles --- */
.item-note {
    font-size: 0.9em;
    color: var(--text-light);
    margin: 5px 0 15px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

/* Custom dropdown arrow styling */
.selectedProduct {
    appearance: none;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right 8px center;
    background-size: 16px 16px;
    padding-right: 30px;
    cursor: pointer;
}


/* ======================================================= */
/* 💻 DESKTOP LAYOUT (Styles for screens >= 768px) */
/* ======================================================= */

@media screen and (min-width: 768px) {
    
    /* --- Container & Title Restore --- */
    .AddProduct {
        padding: 1px 20px;
    }

    .AddProduct h1 {
        font-size: 1.5rem;
        margin: 40px auto; /* Centered on desktop */
        max-width: 700px; /* Limit H1 width slightly */
    }
    
    .product-page-container {
        border-radius: 12px;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08); 
        width: 80%;
        max-width: 1200px;
    }

    /* --- Button Group Layout (Horizontal Alignment) --- */
    .button-group {
        flex-direction: row;
        justify-content: center; 
        gap: 30px; 
        margin-bottom: 40px;
    }

    .button-group .add-button {
        width: auto;
        padding: 12px 24px;
        font-size: 1rem;
    }
    
    /* --- Table Restore --- */
    .data-table {
        border-radius: 12px;
        display: table; 
        overflow-x: hidden;
        white-space: normal;
    }
    
    /* Remove mobile truncation on desktop */
    .data-table tbody td {
        max-width: none;
        overflow: visible;
        text-overflow: clip;
        white-space: normal;
    }


    th, td {
        padding: 15px; 
        font-size: 1rem;
    }

    td button {
        margin-right: 10px;
        padding: 8px 16px;
        border-radius: 6px;
        font-size: 1rem;
    }

    .actions-cell {
        width: 10%; /* Ensures actions column is compact */
    }


    /* --- Form & Modal Restore --- */
    .modal-content {
        padding: 40px;
        max-width: 500px;
        max-height: 80%; 
    }
    
    form input[type="text"],
    form input[type="number"],
    form textarea,
    .selectedProduct {
        padding: 12px;
        font-size: 1rem;
    }
    
    form button[type="submit"] {
        padding: 15px;
        font-size: 1.1rem;
    }
    
    .close-button {
        font-size: 2.5rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/dashboard/ManageDownload.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C,4DAA4D;AAC5D,6BAA6B;AAC7B,4DAA4D;AAC5D,4DAA4D;AAC5D;IACI,uBAAuB;IACvB,wBAAwB;IACxB,sBAAsB;IACtB,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI;QACI,sBAAsB;QACtB,UAAU;IACd;IACA;QACI,mBAAmB;QACnB,UAAU;IACd;AACJ;;;AAGA,4DAA4D;AAC5D,0DAA0D;AAC1D,4DAA4D;;AAE5D,sCAAsC;;AAEtC;IACI,iBAAiB;IACjB,gCAAgC;IAChC,iBAAiB;IACjB,4DAA4D;AAChE;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,6EAA6E;IAC7E,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,iCAAiC;IACjC,kBAAkB;IAClB,0CAA0C;IAC1C,cAAc;AAClB;;AAEA,kDAAkD;AAClD;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA,gCAAgC;AAChC;IACI,qCAAqC;IACrC,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,2DAA2D;IAC3D,6CAA6C;IAC7C,WAAW;IACX,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA,0BAA0B;;AAE1B;IACI,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA,iEAAiE;AACjE;IACI,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;;AAGA;IACI,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA,0BAA0B,iCAAiC,EAAE,wBAAwB,EAAE;AACvF,2BAA2B,yBAAyB,EAAE,wBAAwB,EAAE;;AAEhF,iCAAiC;AACjC;IACI,mDAAmD;IACnD,iBAAiB;IACjB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,uBAAuB;IACvB,sCAAsC;IACtC,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,uEAAuE;AACvE;IACI,yBAAyB,EAAE,qCAAqC;IAChE,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;;AAGA,8DAA8D;AAC9D;IACI,oCAAoC;IACpC,YAAY;IACZ,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA,4DAA4D;AAC5D,4BAA4B;AAC5B,4DAA4D;;AAE5D;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,2BAA2B;IAC3B,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,0CAA0C;IAC1C,UAAU;IACV,oCAAoC;IACpC,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,uCAAuC;;AAEvC;IACI,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;;;;IAII,WAAW;IACX,aAAa;IACb,qCAAqC;IACrC,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,wDAAwD;AAC5D;;AAEA;;;IAGI,aAAa;IACb,iCAAiC;IACjC,6CAA6C;AACjD;;AAEA,yCAAyC;AACzC;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA,kDAAkD;AAClD;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA,yEAAyE;AACzE;IACI,cAAc;IACd,YAAY,EAAE,8DAA8D;IAC5E,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB,EAAE,2CAA2C;IACjE,+CAA+C;AACnD;;;AAGA,oCAAoC;AACpC;IACI,WAAW;IACX,aAAa;IACb,sCAAsC;IACtC,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,+BAA+B;AAC/B;IACI,gBAAgB;IAChB,wBAAwB;IACxB,oBAAoB;IACpB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA,kCAAkC;AAClC;IACI,gBAAgB;IAChB,yDAAkL;IAClL,4BAA4B;IAC5B,qCAAqC;IACrC,0BAA0B;IAC1B,mBAAmB;IACnB,eAAe;AACnB;;;AAGA,4DAA4D;AAC5D,oDAAoD;AACpD,4DAA4D;;AAE5D;;IAEI,sCAAsC;IACtC;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;QACjB,iBAAiB,EAAE,wBAAwB;QAC3C,gBAAgB,EAAE,4BAA4B;IAClD;;IAEA;QACI,mBAAmB;QACnB,0CAA0C;QAC1C,UAAU;QACV,iBAAiB;IACrB;;IAEA,uDAAuD;IACvD;QACI,mBAAmB;QACnB,uBAAuB;QACvB,SAAS;QACT,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,eAAe;IACnB;;IAEA,0BAA0B;IAC1B;QACI,mBAAmB;QACnB,cAAc;QACd,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA,wCAAwC;IACxC;QACI,eAAe;QACf,iBAAiB;QACjB,mBAAmB;QACnB,mBAAmB;IACvB;;;IAGA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,iBAAiB;QACjB,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,UAAU,EAAE,sCAAsC;IACtD;;;IAGA,iCAAiC;IACjC;QACI,aAAa;QACb,gBAAgB;QAChB,eAAe;IACnB;;IAEA;;;;QAII,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":["/* ManageDownload.css - Final Revised Version */\n\n/* ======================================================= */\n/* 🔑 VARIABLES & KEYFRAMES */\n/* ======================================================= */\n/* Defining common colors and fonts for easier maintenance */\n:root {\n    --primary-blue: #3498db;\n    --primary-green: #2ecc71;\n    --primary-red: #e74c3c;\n    --text-dark: #34495e;\n    --text-light: #666;\n    --bg-dark: #303030;\n    --bg-light: #fff;\n    --border-color: #e0e6ed;\n}\n\n@keyframes modalFadeIn {\n    from {\n        transform: scale(0.95);\n        opacity: 0;\n    }\n    to {\n        transform: scale(1);\n        opacity: 1;\n    }\n}\n\n\n/* ======================================================= */\n/* 📱 MOBILE LAYOUT (Default styles for screens < 768px) */\n/* ======================================================= */\n\n/* --- Global & Container Styles --- */\n\n.AddProduct {\n    padding: 1px 10px;\n    background-color: var(--bg-dark);\n    min-height: 100vh;\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.AddProduct h1 {\n    color: var(--bg-light);\n    font-size: 1.3rem;\n    text-align: center;\n    margin: 30px 10px;\n    /* font-family: 'GlitchGoblin', sans-serif; // Ensure this font is imported */\n    font-weight: 600;\n}\n\n.product-page-container {\n    width: 100%;\n    margin: 20px auto;\n    background-color: var(--bg-light);\n    border-radius: 8px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05); \n    overflow: auto;\n}\n\n/* --- Button Group Layout (Mobile Stacking) --- */\n.button-group {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    margin-bottom: 25px;\n}\n\n/* --- Primary Add Buttons --- */\n.AddProduct .add-button {\n    background-color: var(--primary-blue);\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    font-size: 0.95rem;\n    font-weight: 600;\n    cursor: pointer;\n    border-radius: 6px;\n    transition: background-color 0.3s ease, transform 0.2s ease;\n    box-shadow: 0 3px 8px rgba(52, 152, 219, 0.2);\n    width: auto;\n    margin: 0;\n    white-space: nowrap;\n}\n\n.AddProduct .add-button:hover {\n    background-color: #2980b9; \n    transform: translateY(-1px); \n}\n\n/* --- Table Styling --- */\n\n.data-table {\n    width: 100%;\n    border-collapse: separate;\n    border-spacing: 0;\n    border-radius: 8px;\n    overflow: hidden;\n    overflow-x: auto;\n    white-space: nowrap; \n}\n\nth, td {\n    padding: 10px;\n    text-align: left;\n    border-bottom: 1px solid #666;\n    font-size: 0.9rem;\n}\n\n/* Text Truncation for Table Data on mobile to prevent overflow */\n.data-table tbody td {\n    max-width: 150px; \n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.data-table tbody td.actions-cell {\n    max-width: none;\n    overflow: visible;\n    white-space: nowrap;\n}\n\n\nth {\n    background-color: #f8f9fa;\n    color: #495057;\n    font-weight: 600;\n    text-transform: uppercase;\n}\n\ntbody tr:nth-child(odd) { background-color: var(--bg-light); color: var(--text-light); }\ntbody tr:nth-child(even) { background-color: #fcfcfc; color: var(--text-light); }\n\n/* --- Table Action Buttons --- */\n.AddProduct td button {\n    /* Base style for all table buttons (Edit/Delete) */\n    margin-right: 5px; \n    padding: 6px 10px; \n    border: 1px solid #ccc;\n    border-radius: 4px;\n    font-size: 0.8rem;\n    background-color: #f0f3f5;\n    color: var(--text-dark);\n    transition: background-color 0.3s ease;\n    width: auto; \n}\n\n.AddProduct td button:hover {\n    background-color: #e2e6ea;\n}\n\n/* 🌟 REVISION: Explicit Styling for the Edit Button (First Child) 🌟 */\n.AddProduct td button:first-child { \n    background-color: #3498db; /* Primary Blue from your variables */\n    color: white;\n    border-color: #3498db;\n}\n\n.AddProduct td button:first-child:hover {\n    background-color: #2980b9;\n    border-color: #2980b9;\n}\n\n\n/* Table Delete Button (2nd button in the cell in this case) */\n.AddProduct td button:nth-child(2) {\n    background-color: var(--primary-red);\n    color: white;\n    border-color: var(--primary-red);\n}\n\n.AddProduct td button:nth-child(2):hover {\n    background-color: #c0392b;\n}\n\n\n/* ======================================================= */\n/* 🚀 FORM & MODAL STYLING */\n/* ======================================================= */\n\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n.modal-content {\n    background: var(--bg-light);\n    padding: 20px; \n    border-radius: 8px; \n    position: relative;\n    width: 80%; \n    max-width: none; \n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n    opacity: 0;\n    animation: modalFadeIn 0.3s forwards;\n    max-height: 90vh; \n    overflow-y: auto;\n}\n\n.close-button {\n    position: absolute;\n    top: 15px;\n    right: 15px;\n    background: transparent;\n    border: none;\n    font-size: 2rem; \n    cursor: pointer;\n    color: #95a5a6;\n    transition: color 0.2s ease;\n}\n\n.close-button:hover {\n    color: var(--primary-red);\n}\n\n/* --- Form Groups & Input Styles --- */\n\nform > div {\n    /* General spacing for form fields */\n    margin-bottom: 20px;\n}\n\nform label {\n    display: block;\n    margin-bottom: 8px;\n    font-weight: 600;\n    color: var(--text-dark);\n    font-size: 0.95rem;\n}\n\nform input[type=\"text\"],\nform input[type=\"number\"],\nform textarea,\n.selectedProduct { \n    width: 100%;\n    padding: 10px;\n    border: 1px solid var(--border-color);\n    border-radius: 6px;\n    box-sizing: border-box;\n    font-size: 0.95rem;\n    transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\nform input:focus,\nform textarea:focus,\n.selectedProduct:focus {\n    outline: none;\n    border-color: var(--primary-blue);\n    box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.2);\n}\n\n/* 🌟 INPUT GROUP FOR INPUT + BUTTON 🌟 */\n.FormInputGroup .input-with-button {\n    display: flex;\n    align-items: center; \n    gap: 10px; \n}\n\n/* Ensure the input takes up all remaining space */\n.FormInputGroup .input-with-button input[type=\"text\"] {\n    flex-grow: 1;\n    min-width: 0; \n}\n\n/* Style the buttons within the input group to look like the APK button */\n.FormInputGroup-button {\n    flex-shrink: 0; \n    width: 140px; /* Consistent width for both \"Select Image\" and \"Select APK\" */\n    padding: 10px 15px;\n    font-size: 0.95rem;\n    margin: 0 !important; /* Override any potential external margin */\n    /* Visual style is inherited from .add-button */\n}\n\n\n/* --- Modal Submission Button --- */\n.AddProduct .modal-content form button[type=\"submit\"] {\n    width: 100%;\n    padding: 12px;\n    background-color: var(--primary-green);\n    font-weight: 700;\n    font-size: 1rem;\n    border-radius: 6px;\n    color: white;\n    border: none;\n    margin-top: 15px;\n}\n\n.AddProduct .modal-content form button[type=\"submit\"]:hover {\n    background-color: #27ae60;\n}\n\n/* --- Helper/Note Styles --- */\n.item-note {\n    font-size: 0.9em;\n    color: var(--text-light);\n    margin: 5px 0 15px 0;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n/* Custom dropdown arrow styling */\n.selectedProduct {\n    appearance: none;\n    background-image: url('data:image/svg+xml;utf8,<svg fill=\"%23333\" height=\"20\" viewBox=\"0 0 24 24\" width=\"20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7 10l5 5 5-5z\"/></svg>');\n    background-repeat: no-repeat;\n    background-position: right 8px center;\n    background-size: 16px 16px;\n    padding-right: 30px;\n    cursor: pointer;\n}\n\n\n/* ======================================================= */\n/* 💻 DESKTOP LAYOUT (Styles for screens >= 768px) */\n/* ======================================================= */\n\n@media screen and (min-width: 768px) {\n    \n    /* --- Container & Title Restore --- */\n    .AddProduct {\n        padding: 1px 20px;\n    }\n\n    .AddProduct h1 {\n        font-size: 1.5rem;\n        margin: 40px auto; /* Centered on desktop */\n        max-width: 700px; /* Limit H1 width slightly */\n    }\n    \n    .product-page-container {\n        border-radius: 12px;\n        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08); \n        width: 80%;\n        max-width: 1200px;\n    }\n\n    /* --- Button Group Layout (Horizontal Alignment) --- */\n    .button-group {\n        flex-direction: row;\n        justify-content: center; \n        gap: 30px; \n        margin-bottom: 40px;\n    }\n\n    .button-group .add-button {\n        width: auto;\n        padding: 12px 24px;\n        font-size: 1rem;\n    }\n    \n    /* --- Table Restore --- */\n    .data-table {\n        border-radius: 12px;\n        display: table; \n        overflow-x: hidden;\n        white-space: normal;\n    }\n    \n    /* Remove mobile truncation on desktop */\n    .data-table tbody td {\n        max-width: none;\n        overflow: visible;\n        text-overflow: clip;\n        white-space: normal;\n    }\n\n\n    th, td {\n        padding: 15px; \n        font-size: 1rem;\n    }\n\n    td button {\n        margin-right: 10px;\n        padding: 8px 16px;\n        border-radius: 6px;\n        font-size: 1rem;\n    }\n\n    .actions-cell {\n        width: 10%; /* Ensures actions column is compact */\n    }\n\n\n    /* --- Form & Modal Restore --- */\n    .modal-content {\n        padding: 40px;\n        max-width: 500px;\n        max-height: 80%; \n    }\n    \n    form input[type=\"text\"],\n    form input[type=\"number\"],\n    form textarea,\n    .selectedProduct {\n        padding: 12px;\n        font-size: 1rem;\n    }\n    \n    form button[type=\"submit\"] {\n        padding: 15px;\n        font-size: 1.1rem;\n    }\n    \n    .close-button {\n        font-size: 2.5rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
